import { ReactElement } from 'react';
import styled from 'styled-components';
import { validatePassword } from 'Utils/UtilityFunctions';
import { Popover } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';
import { ReactComponent as Elipsis4 } from '../assets/img/icons/Elipsis4.svg';
import { ReactComponent as CheckCircle } from '../assets/img/icons/CheckCircle.svg';
import { ReactComponent as Cross } from '../assets/img/icons/cross.svg';
import '../assets/css/passwordValid.css';

const WrapperStyle = styled.div`
  position: absolute;
  right: 50px;
  top: 25px;
  span{
    color:rgb(94, 112, 121);
    font-size:10px;
    font-family: 'robotoregular';
    cursor: pointer;
    svg{
      margin-left:2px;
    }
  } 
`;

type CheckedListItemProps = {
  isChecked: boolean | string | number,
  content: ReactElement,
};

type PasswordValidProps = {
  open: boolean,
  password: string,
  placement?: TooltipPlacement,
};

const defaultProps = {
  placement: 'rightTop',
};

const CheckedListItem = function CheckedListItem(props: CheckedListItemProps) {
  const { isChecked, content } = props;
  return (
    <div className="valid-password-content-list-item">
      {isChecked ? <CheckCircle /> : <Cross className="cross-icon" />}
      {content}
    </div>
  );
};

const PasswordValid = function PasswordValid(props: PasswordValidProps) {
  const { password, open, placement } = props;
  const { validate } = validatePassword(password);

  // checking the strength
  const strength = Object.values(validate).every((v) => v === true);

  const content = (
    <div className="valid-password-content">
      <div className={`valid-password-title ${strength ? '' : 'weak-pass'}`}>{strength ? 'Strong Password' : 'Weak Password'}</div>
      <div className="valid-password-content-div">
        <CheckedListItem
          isChecked={validate.uppercase}
          content={(
            <div>
              Contain at least one
              {' '}
              <strong>UPPERCASE letter</strong>
            </div>
          )}
        />
        <CheckedListItem
          isChecked={validate.lowercase}
          content={(
            <div>
              Contain at least one
              {' '}
              <strong>LOWERCASE letter</strong>
            </div>
          )}
        />
        <CheckedListItem
          isChecked={validate.number}
          content={(
            <div>
              Contain at least one
              {' '}
              <strong>Number (0-9)</strong>
            </div>
          )}
        />
        <CheckedListItem
          isChecked={validate.special}
          content={(
            <div>
              Contain at least one
              {' '}
              <strong>special character e.g. @,$,!</strong>
            </div>
          )}
        />
        <CheckedListItem
          isChecked={validate.long}
          content={(
            <div>
              Be at least
              {' '}
              <strong>12 characters long</strong>
            </div>
          )}
        />
      </div>
    </div>
  );

  return (
    <WrapperStyle className="password-valid-popover">
      <Popover
        overlayInnerStyle={{ background: '#F8F8F8', borderRadius: '10px' }}
        visible={open}
        placement={placement}
        content={content}
        getPopupContainer={(e: HTMLElement) => e}
        overlayClassName="popover-overlay-class"
        arrow={false}
      >
        <span id="strength-span">
          Strength
          <Elipsis4 />
        </span>
      </Popover>
    </WrapperStyle>
  );
};
PasswordValid.defaultProps = defaultProps;
export default PasswordValid;
